import { combineReducers } from "redux"
import Auth from "./auth/login/reducer"
import Project from "./data/projects/reducer"
import Ticket from "./data/tickets/reducer"

const rootReducer = combineReducers({ Auth, Project, Ticket })

export default rootReducer